<template>
  <section>
    <ion-card v-show="editItemBollean">
      <ion-card-header @click="showDetails()" :style="{ padding: '8px' }">
        <ion-grid class="ion-no-padding">
          <ion-row class="row-margin-bottom">
            <div
              v-if="titleHeader"
              class="ion-text-start"
              :style="{ fontSize: '0.7em', marginRight: '5px' }"
            >
              {{ editItem[titleHeader.value] }}
            </div>
            <small v-if="subTitleHeader">{{
              editItem[subTitleHeader.value]
            }}</small>
          </ion-row>
        </ion-grid>
      </ion-card-header>
      <ion-card-content 
        :class="editItem.invalidItem ? 'ion-no-padding invalid-header' : 'ion-no-padding'">
        <ion-list>
          <template v-for="(field, index) in computedHeadersData" :key="index">
            <ion-item v-show="!field.hide" 
              :class="editItem.invalidItem && editItem.invalidField.header.value === field.value ? 'invalid-header' : 'inherit'">
              <div v-show="!field.hide">
                <ion-label position="floating">{{ field.text }}</ion-label>
                <ion-input
                  :color="editItem.invalidItem && editItem.invalidField.header.value === field.value ? 'danger' : 'undefined'"
                  :type="field.input ? field.input.type : ''"
                  v-model="editItem[field.value]"
                  :disabled="readonly || ((typeof field.editable == 'function') ? !field.editable({editItem, formMaster}) : !field.editable)"
                  @change="blurField({item: editItem, header: field, value: $event.target.value})"
                />
              </div>
            </ion-item>
          </template>
        </ion-list>
        <ion-button :color="editItem.invalidItem ? 'danger' : 'primary'" @click="showDetails()" expand="block">
          <ion-icon :icon="checkmarkOutline"></ion-icon> OK {{editItem.invalidItem ? '(Item com erros)' : ''}}
        </ion-button>
      </ion-card-content>
    </ion-card>
    <ion-page v-show="!editItemBollean && computedFilters && computedFilters.length > 0">
      <ion-content>
        <FormDataTableFilters
          ref="form-data-table-filters"
          :key="tableIdForeignValue"
          :filters="computedFilters"
          :filtersModels="filtersModels"
          :search="search"
          @searching="search.value = $event"
          @filtersChange="filtersModels = $event"
          @clearFilters="clearFilters()"
          @clearSearch="clearSearch()"
        />

        <!-- Loading -->
        <ion-grid v-if="loading" :style="{height: '50%'}">
          <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
            <ion-col size="12">
              <ion-label>Buscando itens</ion-label>
              <br/>
              <ion-spinner name="dots"></ion-spinner>
            </ion-col>
          </ion-row>
        </ion-grid>
  
        <!-- No Data -->
        <ion-grid v-else-if="computedItems && computedItems.length == 0" :style="{height: '50%'}">
          <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
            <ion-col size="12">
              <ion-label color="danger" v-if="isSearched">A pesquisa por "<strong>{{ search.value }}</strong>" não retornou registros, confira os filtros selecionados.</ion-label>
              <ion-label color="danger" v-else-if="isFiltered">Os filtros selecionados não retornaram registros.</ion-label>
              <ion-label color="danger" v-else-if="SA7Filtered">A amarração cliente x produtos não retornou registros.</ion-label>
              <ion-label color="danger" v-else>Sem registros.</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-card v-for="(item, index) in computedItems" :key="index" 
            :class="item.invalidItem ? 'invalid-item' : item.warnedItem ? 'warned-item' : 'inherit'">
          <ion-card-header @click="showDetails(item)" :style="{ padding: '8px' }">
            <ion-grid class="ion-no-padding">
              <ion-row class="row-margin-bottom">
                <div
                  v-if="titleHeader"
                  class="ion-text-start"
                  :style="{ fontSize: '0.7em', marginRight: '5px' }"
                >
                  {{ item[titleHeader.value] }}
                </div>
                <small v-if="subTitleHeader">{{
                  item[subTitleHeader.value]
                }}</small>
              </ion-row>
              <template v-if="!item.show">
                <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
                <ion-row class="ion-justify-content-between">
                  <div v-for="(header, index) of allHeaders" :key="index" 
                    :class="item.invalidItem && item.invalidField?.header.value === header.value ? 'invalid-header' : item.warnedItem  && item.warnedField?.header.value === header.value ? 'warned-item' : 'inherit'">
                    <ion-row class="ion-justify-content-center">
                      <small>{{ header.text }}</small>
                    </ion-row>
                    <ion-row class="ion-justify-content-center">
                      {{ getFormatValue(header, item) }} 
                    </ion-row>
                  </div>
                </ion-row>
              </template>
            </ion-grid>
          </ion-card-header>

          <ion-card-subtitle v-if="item.invalidItem" :style="{ padding: '0 8px 1px' }">
            <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
            <template v-if="item.errorMessages && item.errorMessages.length > 0">
              <ion-text :style="{ display: 'block', marginBottom: '4px' }" color="danger" v-for="(error, idx, key) in item.errorMessages" :key="key" v-html="`${error}`"></ion-text>
            </template>
          </ion-card-subtitle>

          <ion-card-subtitle v-if="item.warnedItem" :style="{ padding: '0 8px 1px' }">
            <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
            <template v-if="item.warnMessages && item.warnMessages.length > 0">
              <ion-text :style="{ display: 'block', marginBottom: '4px' }" color="warning" v-for="(warn, idx, key) in item.warnMessages" :key="key" v-html="`${warn}`"></ion-text>
            </template>
          </ion-card-subtitle>
        </ion-card>

        <!-- Scroll Next -->
        <ion-infinite-scroll
          @ionInfinite="loadData($event)"
          threshold="100px"
          id="infinite-scroll"
          ref="infiniteScroll"
          :disabled="readonly || disabledScroll">
          <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Buscando mais dados...">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>

      </ion-content>
      
    </ion-page>
  </section>
</template>

<script>
import store from "../store";
import { createNamespacedHelpers } from "vuex";
const { mapState: registersState, mapActions: registersActions, mapMutations: registersMutations } = createNamespacedHelpers("registers");
import FormDataTableFilters from './FormDataTableFilters.vue'
import {  
  chevronDown, 
  chevronUp, 
  close,
  checkmarkOutline 
} from "ionicons/icons";
import {
  IonCard,
  IonContent,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonList,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonLabel,
  IonInput,
  // IonFooter,
  IonSpinner,
  IonButton,
  IonIcon,
  IonInfiniteScroll,
  IonPage,
  IonInfiniteScrollContent
  // IonModal,
} from "@ionic/vue";

export default {
  name: "FormDataTable",
  components: {
    IonContent,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonText,
    IonSpinner,
    IonGrid,
    IonRow,
    IonCol,
    // IonSearchbar,
    IonList,
    IonItem,
    IonLabel,
    IonInput,
    // IonToggle,
    IonButton,
    IonIcon,
    // IonProgressBar,
    // IonFooter,
    IonPage,
    FormDataTableFilters,
    IonInfiniteScroll,
    IonInfiniteScrollContent
    // IonModal,
  },
  emits: ["validated", "setTotalize"],
  props: {
    props: {
      type: Object,
      default: () => {}
    },
    headers: Array,
    tableIdForeignValue: String,
    formMaster: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
    tableSA7: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => [],
    },
    itemsDetails: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "teal",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    exportXls: {
      type: Boolean,
      default: true,
    },
    xlsxName: {
      type: String,
    default: "itens",
    },
    filterItems: {
      type: Function,
      default: (item) => item,
    },
  },
  data() {
    return {
      editItem: {},
      editItemBollean: false,
      itemsProcessed: [],
      quantity: 0,
      titleHeader: {},
      subTitleHeader: {},
      allHeaders: [],
      errorMessages: [],
      headersData: [],
      loadingItems: true,
      loading: false,
      // loadedItems: [],
      showItems: false,
      disabledScroll: false,
      invalidItems: [],
      search: {
        value: "",
      },
      filtersModels: {
        invalidItem: false,
        warningCells: false
      },
      SA7: null,
      itemsDetailsEditable: [],
      sortBy: null,
      sortMod: null,
      itensPerPage: 20,
      andFilters: [],
      orFilters: [],
      timeoutSearch: null,
    };
  },
  computed: {
    ...registersState(['registers']),
    
    collection() { return this.props.tableCollection },
    subCollection() { return this.props.tableSubcollection },
    register() { 
      let register = (this.subCollection) ? `${this.collection}.${this.subCollection}` : this.collection 
      if (this.isSearched) { register = `${register}Filtered` }
      return register
    },
    filtersSubcollection() { return this.props.filtersSubcollection },
    orderBy() {
      let orderBy = this.props.orderSubcollection 
      if (typeof orderBy == 'string') orderBy = {field: orderBy, mod: 'asc'}
      if (this.sortBy) orderBy.field = this.sortBy
      if (this.sortMod) orderBy.mod = this.sortMod
      return orderBy
    },
    serverItemsLength() { return (this.isSearched) ? this.totalSearched : this.itemsTotal }, 

    computedHeadersData(){
      return this.headersData
    },
    computedItemsProcessed() {
      return this.itemsProcessed
    },
    headersMobile() {
      return this.computedHeadersData.filter((h) => h.mobile && !h.mobile.justTotalize);
    },

    searchableHeaders() { return this.computedHeadersData.filter(x => x.searchable) },
    filterSearchable() { return this.computedHeadersData.filter(x => x.filterSearchable) },
    computedFilters() {
      const filters = this.headers.filter((x) => x.filterable === true && x.filterType == 'switch');
      filters.forEach(el => {
        const ixH = this.computedHeadersData.findIndex(x => x.value === el.value)
        switch (el.filterType) {
          case 'switch':
            this.headersData[ixH].filter = (header, item) => {
              const validated = (item[header.value] || !this.filtersModels[el.value])
              if (this.filtersModels.invalidItem)
                return validated /*&& !row.validated()*/
              return validated
            }
            break;
        
          default:
            this.headersData[ixH].filterItems =  [ ...new Set(this.computedItemsProcessed.map(x => x[el.value])) ]
            this.headersData[ixH].filter = (header, item) => {
              if (!this.filtersModels[el.value])
                return true
              if (this.filtersModels[el.value].length === 0)
                return true

              const validated = this.filtersModels[el.value].findIndex(n => n == item[header.value]) > -1
              if (this.filtersModels.invalidItem)
                return validated /*&& !row.validated()*/
              return validated
            }
            break;
        }
      })
      
      filters.push({
        filterType: 'switch',
        filterLabel: 'Com aviso',
        value: 'warningCells',
        hide: this.readonly
      })
      filters.push({
        filterType: 'switch',
        filterLabel: 'Com erro',
        value: 'invalidItem',
        hide: this.readonly
      })
      return filters
    },
    totalize() {
      let totalize = null;
        totalize = [];
        this.computedHeadersData
          .filter((x) => x.totalize)
          .forEach((elx) => {
            const total = (this.itemsDetailsEditable && this.itemsDetailsEditable.length > 0) ? this.itemsDetailsEditable
              .map((x) => (x[elx.value]*1))
              .reduce((acc, cur) => acc + cur): 0;
            const prefix = elx.prefix ? elx.prefix + " " : "";
            const suffix = elx.suffix ? " " + elx.suffix : "";
            if (elx.totalizeSelecteds){
              const selecteds = this.itemsDetailsEditable
                .filter((x) => x[elx.value])
                .length
              totalize.push({
                mobile: true,
                label: elx.totalizeSelectedsLabel || elx.totalizeLabel || elx.text,
                text: selecteds,
                value: `${elx.value}Selecteds`,
              });
            }
            totalize.push({
              label:  elx.totalizeLabel || elx.text,
              mobile: elx.mobile,
              text:
                prefix +
                total.toLocaleString("pt-br", {
                  minimumFractionDigits: elx.precisionText,
                  maximumFractionDigits: elx.precisionText,
                }) +
                suffix,
              value: elx.value,
            });
          });
      return totalize;
    },
    items() {
      let items = []
      if (this.readonly) {
        items = store.$_.cloneDeep(this.itemsDetailsEditable)
      } else {
        items = this.registers[this.register]
        if (!this.tableIdForeignValue || !items || !items.length > 0) return []
      
        // Removendo itens duplicados, deixando a data de vigencia ativa mais recente
        if (this.subCollection == 'DA1') {
          const now = store.$moment(new Date()).format("YYYYMMDD")
          items = items
            // Filtra itens apenas dentro da vigencia
            .filter(x => x.DA1_DATVIG <= now)
            // Ordena itens pelo código e vigencia, DESC
            .sort((a, b) => {
              if (a.DA1_CODPRO+a.DA1_DATVIG > b.DA1_CODPRO+b.DA1_DATVIG) {return -1}
              else if (a.DA1_CODPRO+a.DA1_DATVIG < b.DA1_CODPRO+b.DA1_DATVIG) {return 1}
              else {return  0}
            })
            // Remove duplicados com base no código
            .filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.DA1_CODPRO === value.DA1_CODPRO
              ))
            )
            // Retorna a ordenação padrão
            .sort((a, b) => {
              if (a[this.props.orderSubcollection] < b[this.props.orderSubcollection]) {return -1}
              else if (a[this.props.orderSubcollection] > b[this.props.orderSubcollection]) {return 1}
              else {return  0}
            })
        }
        
        // Mapeando preenchimento
        items = items.map(item => {
          let filteredItem = {}
          this.props.headersDetails.forEach(header => {
            filteredItem[header.value] = (header.fill && item[header.fill]) ? item[header.fill] : item[header.value]
            
            if (typeof filteredItem[header.value] === 'undefined') {
              filteredItem[header.value] = header.default
            }
          })
          return filteredItem
        })
      
        // Filtro SA7
        if (this.SA7Filtered) {
          const SA7Cod = this.SA7.map(x => x.A7_PRODUTO.trim())
          items = items.filter(x => SA7Cod.includes(x.DA1_CODPRO.trim()))
            .map(x => ({...x, ...this.SA7.find(y => y.A7_PRODUTO.trim() == x.DA1_CODPRO.trim())}))
        }

        // Itens rascunho
        if (this.itemsDetailsEditable.length > 0) {
          // Adicionando items de rascunho que não existem na listagem carregada
          if (!this.isSearched) {
            for (const itemsDetails of this.itemsDetailsEditable) {
              const ix = items.findIndex(_item => this.props.headersDetails.filter(h => h.identifier).every(h => itemsDetails[h.value] == _item[h.value]))
              if (ix == -1) { items.push(itemsDetails) }    
            }
          }
    
          // Preenchendo tabela de items com itens de rascunho
          items = items.map(item => ({...item, ...this.itemsDetailsEditable.find(_item => this.props.headersDetails.filter(h => h.identifier).every(h => item[h.value] == _item[h.value]))}) || item)
        }
      }
      
      return items
    },
    SA7Filtered() {
      return this.SA7 && this.SA7.length > 0
    },
    isSearched() {
      return (this.search && this.search.value)
    },
    isFiltered() {
      if (this.search && this.search.value && this.search.value.length > 0)
        return true
      
      return Object.entries(this.filtersModels)
        .some(([_, model]) => {
          if (Array.isArray(model) && model.length > 0)
            return true
          if (typeof model == "boolean" && model)
            return true
          return false
        })
    },
    computedItems() {
      const someItemExpanded = this.computedItemsProcessed.some(i => i.show)
      const filters = Object.entries(this.filtersModels).filter(([key,value]) => Array.isArray(value) && value.length === 0 ? false : true).map(([key, value]) =>  ({header: key, value}) )
      const itemsShowed = this.computedItemsProcessed.filter(i => i.show || !someItemExpanded)
      return (!this.isFiltered) ? itemsShowed : itemsShowed.filter(i => {
        const validFilters = filters.every(f => {
          if (typeof f.value === 'boolean') {
            return !f.value || i[f.header]
          } else if (typeof i[f.header] === 'undefined') { 
            return true
          } else {
            return f.value.some(filter => (filter+'').trim().toLowerCase() === (i[f.header]+'').trim().toLowerCase())
          }
        })
        // const searcher = this.headersMobile.map(hm => (i[hm.value] + '').toLowerCase().trim()).join('')
        return validFilters // && searcher.includes(this.search.value.toLowerCase().trim())
      })
    },
    validated() {
      return !(this.computedItemsProcessed.filter(i => i.invalidItem).length > 0) && this.computedItemsProcessed.filter(this.filterItems).length > 0
    },
  },
  watch: {
    tableIdForeignValue(val, oldVal) {
      if (oldVal != null) { this.resetFormDataTable() }
      if (!this.readonly) {
        this.loading = true
        this.getTableItems({id: val})
      }
    },
    itemsDetails(val) {
      this.itemsDetailsEditable = val
    },
    items(newValue) {
      this.computeItems()
    },
    search: {
      handler(val, oldVal) {
        if (val.value) {
          this.loading = true
          this.resetRegister(this.register)
          if (this.timeoutSearch) { clearTimeout(this.timeoutSearch) }
  
          this.timeoutSearch = setTimeout(() => {
            this.timeoutSearch = null
            this.orFilters = []
            this.andFilters = []
      
            // Replace especial chars
            let search = val.value.replace(/\+|\/|\.|\(|\)/g, '')

            // Busca segmentada
            if (search.includes('%%')) {
              search = search.split('%%')
              for (let ix = 1; ix < search.length; ix++) {
                const el = search[ix]
                const header = this.filterSearchable[ix-1]
                if (el && header) {
                  this.andFilters.push({
                    key: header.fill || header.value,
                    operator: 'like',
                    value: el.trim()
                  })
                }
              }
              search = search[0].trim()
            }

            for (const header of this.searchableHeaders) {
              this.orFilters.push({
                key: header.fill || header.value,
                operator: 'like',
                value: search
              })
            }

            this.getTableItems()
          }, 1000)
        }
      },
      deep: true
    },
  },
    methods: {
    ...registersMutations(['resetRegister']),
    ...registersActions(["get", "getById", "getOnMongo", "nextOnMongo"]),

    async getTableItems({id = this.tableIdForeignValue} = {}) {
      if (!id) return
      const res = await this.getOnMongo({
        register: this.register, 
        collection: this.collection, 
        subCollection: this.subCollection,
        id,
        filters: [...this.andFilters, ...this.filtersSubcollection], 
        orFilters: this.orFilters,
        orderBy: this.orderBy, 
        limit: this.itensPerPage,
        getTotal: true
      }).catch(err => this.loading = false)
      
      if (this.isSearched && res && res.meta && res.meta.total) { this.totalSearched = res.meta.total }
      else if (res && res.meta && res.meta.total) { this.itemsTotal = res.meta.total }
      else { this.loading = false }
     
      if (this.subCollection == 'DA1' && this.tableSA7) {
        // Verifica se existe amarração x cliente (SA7)
        this.getSA7()
      }
      
      this.loading = false
      return res
    },

    resetFormDataTable () {
      this.resetRegister(this.register)
      this.search.value = null
      this.orFilters = []
      this.andFilters = []
      this.itemsDetailsEditable = []
      this.filtersModels = {
        invalidCells: false,
        warningCells: false,
      }
    },

    resetTableItems () {
      this.disabledScroll = false
      this.loading = false
    },

    clearSearch() {
      this.resetTableItems()
    },

    clearFilters() {
      this.resetTableItems()
    },

    dispatchClearFilters() {
      this.$refs['form-data-table-filters'].clearFilters()
    },
    
    async getSA7() {
      const item = this.$refs.formMaster.getModel()
      if (item && item.SA1 && item.SA1.A1_COD) {
        this.SA7 = this.get({
          collection: 'SA7', 
          filters: [
            {key: "A7_CLIENTE", operator: '==', value: item.SA1.A1_COD},
            {key: "A7_LOJA", operator: '==', value: item.SA1.A1_LOJA},
          ], 
          limit: 9999,
          forceFilter: true,
          setRegister: false
        })
      }
    },

    getModel() {
      const itemsProcessed = this.computedItemsProcessed.map(item => {
        this.computedHeadersData.forEach(header => {
          if (header.type == 'integer') {
            item[header.value] = parseInt(item[header.value])
          } else if (header.type == 'float') {
            item[header.value] = parseFloat(item[header.value])
          }
        })
        return item
      })
      return itemsProcessed
    },
    getTable() {
      return this.computedItemsProcessed.map(item => {
        let itemTable = {}
        for (let header of this.computedHeadersData) {
          itemTable[header.value] = this.getFormatValue(header, item)
        }
        return itemTable
      })
    },
    showDetails(item) {
      this.editItemBollean = !this.editItemBollean
      this.editItem = (this.editItemBollean && item) ? item : {}
    },
    validate() {
      const allValidations = this.computedItemsProcessed.filter(this.filterItems).every(item => 
        this.computedHeadersData.filter(header => header.validation).every(header => 
          header.validation.every((f) => {
            const validated = f(item);
            if (typeof validated == "string") {
              this.errorMessages.push(validated)
              return false;
            } else {
              return validated;
            }
          })
        )
      )

      return allValidations;
    },
    getTotalize() {
      return this.totalize;
    },
    getMaskedValue({header, item}) {
      const value = item[header.value] ? item[header.value] : header.default ? header.default : null
      if (typeof value === 'null' || typeof value === 'NaN') return ''

      const maskedValue = header.type == 'float' || header.type == 'integer'
        ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
        : value

      const prefix = header.prefix ? header.prefix + " " : "";
      const suffix = header.suffix ? " " + header.suffix : "";

      return prefix + maskedValue + suffix;
    },
    async fetchFiltersCollections() {
      await Promise.all(
        this.filters.map(async (filter) => {
          if (filter.method && filter.method.collectionName) {
            const response = await this.get({
              collection: filter.method.collectionName,
              register: filter.method.collectionName,
              orderBy: "indice",
            });
            filter.method.values = response.map(
              (item) => item[filter.method.collectionField]
            );
            return response;
          }
          return Promise.resolve();
        })
      );
    },
    blurField({ item, value, header }) {
      this.process({ item, value, header }) 
      this.$emit('validated', this.validated)
      this.$emit('setTotalize', this.totalize)
    },
    process({ item, value, header }) {
      this.setValue({item, header, value})

      this.warnField({header, item})
      
      this.validateField({header, item})

      // Os headers/atributos a serem usados como busca não devem incluir o próprio elemento que está sendo alterado.
      const headers = this.computedHeadersData.filter(h => h.value != header.value)

      // Array com os dependentes diretos do header, elimina a possibilidade do elemento ser dependente *direto* dele mesmo devido ao filter.
      const directDependentAttributes = this.getDependentAttributes(header, headers)

      // Headers a serem computados respeitando a ordem de precedência da menor posição do array pra maior.
      const dependencyChain = this.getDependencyChain(directDependentAttributes, headers)

      // for of para respeitar a ordem do array `dependencyChain`, que é a ordem de prioridade.
      for (const dependentHeaders of dependencyChain) {
        dependentHeaders.forEach(header => {
          this.computeItem({item, header})
        })
      }
    },
    /**
     * Retorna um array de headers que dependem *diretamente* do `header` passado no primeiro parâmetro
     */
    getDependentAttributes (header, headers) {
      return headers.filter(h => h.dependents && h.dependents.includes(header.value))
    },
    /**
     * Retorna uma cadeia de headers que são dependentes dos headers passados no primeiro argumento.
     * A ordem dos elementos no array indicam o grau de dependência dos headers.
     */
    getDependencyChain(dependents, headers, dependencyChain = []) {
      if (dependents.length == 0)
        return dependencyChain

      const filteredHeaders = headers.filter(h => !dependents.includes(h))
      const newDependents = dependents
        .map(h => this.getDependentAttributes(h, filteredHeaders))
        .reduce((acc,arr) => [...acc, ...arr.filter(el => !acc.includes(el))], [])

      return this.getDependencyChain(newDependents, filteredHeaders, [...dependencyChain, dependents])
    },

    computeItems(){
      this.itemsProcessed = this.items.map(item => {
        this.computedHeadersData.forEach(header => {
          item[header.value] = item[header.value] != undefined ? 
                                item[header.value] : 
                                'default' in header ? 
                                  header.default : null
        })

        // const computeFirstHeaders = this.headers.filter(h => h.computeFirst !== false)

        // computeFirstHeaders.forEach((header) => 
        //   this.computeItem({item, header})
        // )
        if (item.invalidItem == 'undefined') item.invalidItem = false
        return item
      })
      this.loadingItems = false
      this.$emit('validated', this.validated)
      this.$emit('setTotalize', this.totalize)
    },

    computeItem({item, header}) {
      if (!header || !header.dependents) return 
      const itemDependent = this.getDependentsItem({item, header})
      const computedValue = header.computed({item: itemDependent}) 
      this.setValue({item, header, value: computedValue})
    },

    getDependentsItem({header, item}) {
      return header.dependents.reduce((acc, dependent) => {
        return { ...acc, [dependent]: item[dependent] }
      }, {})
    },

    setValue({value, item, header}, { validate = true, set = true, mask = true, verbose = true } = { validate: true, set: true, mask: true, verbose: true }) {
      if (value == null) {
        if (verbose)
          console.warn(`${header.value} "value" is null`)

        text = ""
        item[header.value] = value

        if (header.required) {
          this.validated = false
          this.errorMessages.push('Campo obrigatório')
        }
        return
      } 

      const valueBkp = value
      if (header.type == 'integer') {
        value = parseInt(value)
        if (isNaN(value)) {
          if (verbose) {
            console.warn(`${header.value} "value (${valueBkp})" is NaN`)
          }
          value = 0
          // return
        }
      } else if (header.type == 'float') {
        value = parseFloat(value)
        if (isNaN(value)) {
          if (verbose) {
            console.warn(`${header.value} "value (${valueBkp})" is NaN`)
          }
          // return
          value = 0
        } 
        value = this.fixPrecision(value, header.precisionValue)
      }

      if (set) {
        item[header.value] = header.set ? header.set({value, item}, this.formMaster) : value
      } else {
        item[header.value] = value
      }

      // const text = this.getMaskedValue({header, item})

      // console.info('text', text);
      // this.validated = validate ? this.validate() : true

      // altera no item original somente se estiver validado
      // if (this.validated)
      //   this.row.item[this.name] = item[header.value]

      const ix = this.itemsDetailsEditable.findIndex(
        _item => this.props.headersDetails.filter(h => h.identifier).every(h => item[h.value] == _item[h.value])
      )
      if (ix > -1) {
        this.itemsDetailsEditable[ix] = item
      } else {
        this.itemsDetailsEditable.push(item)
      }
    },

    validateField({item, header}) {
      const { validation = [] } = header
      if (validation && validation.length > 0) item.errorMessages = []
      return validation.every(f => {
        const validated = f(item)
        if (typeof validated == 'string') {
          item.invalidField = { header }
          item.invalidItem = true
          item.errorMessages.push(validated)
          return false
        } else {
          item.invalidField = validated ? { header } : null
          item.invalidItem = !validated
          return validated
        }
      })
    },

    warnField({header, item}) {
      const { warning = [] } = header
      if (warning && warning.length > 0) item.warnMessages = []
      for (const f of warning) {
        const warned = f(item)
        if (typeof warned == 'string') {
          item.warnedField = { header }
          item.warnedItem = true
          item.warnMessages.push(warned)
        } else {
          item.warnedField = warned ? { header } : null
          item.warnedItem = warned
        }
      }
    },

    fixPrecision(value, precision = 4) {
      if (!Number.isFinite(value)) {
        return NaN
      }

      let fixed = value
      if (!Number.isInteger(fixed)) {
        let [integerPart, mantissa] = fixed.toString().split('.')
        
        if (mantissa && mantissa.length > precision) {
          const balanceDigit = parseInt(mantissa[precision])
          if (balanceDigit >= 5) {
            let fix = (parseInt(`${integerPart}${mantissa.slice(0, precision)}`) + 1).toString()
            fix = fix.padStart(integerPart.length+precision, '0')
            
            integerPart = fix.slice(0, fix.length - precision)
            mantissa = fix.slice(-precision)
          } else {
            mantissa = mantissa.slice(0, precision)
          }
          fixed = parseFloat(integerPart + '.' + mantissa)
        }
      }

      return fixed
    },
    getFormatValue(header, item) {
      let value = item[header.value]
      const prefix = header.prefix
        ? header.prefix + ' '
        : ''

      if (typeof value === 'undefined' || value === null) {
        if (typeof header.default !== 'undefined') {
          value = header.default
        } else if (header.type == 'float' || header.type == 'integer') {
          value = 0
        } else {
          value = ''
        }
      }

      const maskedValue = header.type == 'float' || header.type == 'integer'
        ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
        : value

      const suffix = header.suffix
        ? ' ' + header.suffix
        : ''

      return prefix + maskedValue + suffix
    },
    // pushData() {
    //   const max = this.loadedItems.length + 20;
    //   const min = max - 20;
    //   console.info('this.loadedItems', this.loadedItems);
    //   console.info('max', max);
    //   console.info('min', min);
    //   for (let i = min; i < max; i++) {
    //     this.loadedItems.push(this.computedItems[i]);
    //   }
    //   this.showItems = true
    // },
    // toggleInfiniteScroll() {
    //   this.disabledScroll = !this.disabledScroll;
    // },
    loadData(event) {
      this.nextOnMongo({ register: this.register, limit: this.itensPerPage })
        .then(res => { if (!res) { this.disabledScroll = true } })
        .catch(err => this.disabledScroll = true)
        .finally(() => event.target.complete())
    },
    // searchEnabled($event) {
    //   this.showItems = false
    //   this.search.value = $event
    //   this.loadedItems = []
    //   this.loadData()
    // }
  },
  setup() {
    return {
      chevronDown,
      chevronUp,
      close,
      checkmarkOutline
    };
  },
  created() {
    this.headersData = this.headers
    this.fetchFiltersCollections()
    this.titleHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "title"
    );
    this.subTitleHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "subTitle"
    );
    this.allHeaders = this.headersMobile
      .filter((hm) => hm.mobile.type === "all")
      .sort((h1, h2) => {
        if (h1.mobile.horizontalPosition > h2.mobile.horizontalPosition)
          return 1;
        if (h1.mobile.horizontalPosition < h2.mobile.horizontalPosition)
          return -1;
        return 0;
      });
  },
};
</script>

<style scoped>
  .row-margin-bottom {
    margin-bottom: 8px;
  }
  .invalid-item, .invalid-header {
    border: 1pt solid var(--ion-color-danger);
  }
  .warned-item, .warned-header {
    border: 1pt solid var(--ion-color-warning);
  }
  .invalid-header *:not(ion-button, ion-icon) {
    color: var(--ion-color-danger)
  }
  ion-input, ion-select, ion-textarea, ion-button {
    color: darkgrey!important;
    -webkit-text-fill-color: darkgrey!important;
    opacity: 1!important; /* required on iOS */
  }
</style>